import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ModulesComponent } from '../modules/modules.component';
import { UtilService } from 'src/app/services/util.service';
// import { debug } from 'console';

@Component({
  selector: 'app-allmodules',
  templateUrl: './allmodules.component.html',
  styleUrls: ['./allmodules.component.css']
})
export class AllmodulesComponent implements OnInit {

  breadcrumb : BreadCrumb[];
  headerbtn : HeaderButton[];
  myModuleList:any[];
  moduleNotification:any;
  modulesURL: string;
  currentUserIsAdmin: boolean = false;
  @ViewChild('modulesComponent', { static: false }) modulesComponent: ModulesComponent;

  constructor(public headerinfo : ComponentheaderService, public modulemanager : ModulemanagementService, private router : Router, private route: ActivatedRoute, private util: UtilService) { 
    let breadCrumbDisplaytext = this.router.url === '/site/courses' ? 'Courses' : 'Search Courses';
    this.breadcrumb = [ {displaytext: breadCrumbDisplaytext, route: this.route.snapshot.url.join('/'), params: this.route.snapshot.queryParams}];  

    this.route.queryParams.subscribe(x => {
      let searchString = x.searchstring ? x.searchstring : "";
      let filter = x.filter ? x.filter : 2;
      this.headerinfo.setHeaderDisplay(this.router.url === '/site/searchmodules' ? `Search: "${searchString}"`: "", this.breadcrumb, []);
      this.modulesURL = this.modulemanager.getSearchModulesURL(searchString, filter);
      if(this.modulesComponent)
      {
        //debugger;
        
        this.loadModules();
      }
    });
  }

  loadModules(){
    this.modulesComponent.modulesURL = this.modulesURL;
    this.modulesComponent.reload();
  }

  async ngOnInit() {  
    this.currentUserIsAdmin = await this.util.checkUserIsSubdomainAdmin().toPromise();
    this.loadModules();
    // this.route.queryParams.subscribe(x =>
    //   {
    //     console.log('subscribed', x);
    //     //debugger;
    //     this.modulesURL = this.modulemanager.getSearchModulesURL(x.searchstring);
    //     this.modulesComponent.modulesURL = this.modulesURL;
    //     this.modulesComponent.reload();
    //   });

  }

}
